export default __webpack_public_path__ + "images/flight_out.b65c63a.png";